import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const PieChartGlyph = /*#__PURE__*/createElement("g", {
  id: "pie_chart",
  transform: "scale(3.2, 3.2)",
  fill: "none"
}, /*#__PURE__*/createElement("circle", {
  cx: "9.5",
  cy: "9.5",
  r: "9"
}), /*#__PURE__*/createElement("path", {
  d: "M9.5 10L16 3.5"
}), /*#__PURE__*/createElement("path", {
  d: "M9.49998 9.9999L15.5 16"
}));
const PieChart = createSvg({
  name: 'pie_chart',
  path: PieChartGlyph
});

export default PieChart;
export { PieChartGlyph };
